import React, { useState } from "react";
import styles from "./hurdle.module.css";
import { v4 } from "uuid";
import DescriptionWrapper from "./description-wrapper";
import { HURDLE_TITLE_ENG, LOCALES } from "../../constants";
import { getUIText } from "../../translation";
import { getJourneyTimeString } from "../../functions/stringFunctions";

export default function Hurdle({ lang, schedules, setSelected }) {
    const [isFold, setIsFold] = useState(false);

    return (
        <div className={`${styles["hurdle"]} ${isFold ? "" : `${styles["active"]}`}`}>
            <button type="button" className={styles["hurdle-title"]} onClick={() => setIsFold(!isFold)}>
                {lang === LOCALES.KO ? schedules[0].title : HURDLE_TITLE_ENG[schedules[0].title]}
                <span className={styles["triangle"]}>▼</span>
            </button>
            <div className={styles["turns"]}>
                {schedules.map((turn) => {
                    return (
                        <div className={styles["turn"]} key={v4()}>
                            <div className={styles["turn-info"]}>
                                <div className={styles["title"]}>
                                    <span className={styles["turn-count"]}>
                                        {turn.turn}
                                        {getUIText(lang, "schedule.turn")}
                                    </span>
                                    <span className={styles["turn-time"]}>{getJourneyTimeString(lang, turn.time)}</span>
                                </div>
                                <div className={styles["turn-description"]}>
                                    {turn.befores.length > 0 && (
                                        <div className={styles["description-title"]}>{getUIText(lang, "schedule.turn.action.before")}</div>
                                    )}
                                    {turn.befores.length > 0 &&
                                        turn.befores.map((before, index) => {
                                            return <DescriptionWrapper lang={lang} desc={before} setSelected={setSelected} key={v4()} />;
                                        })}

                                    {turn.currents.length > 0 && (
                                        <div className={styles["description-title"]}>{getUIText(lang, "schedule.turn.action")}</div>
                                    )}
                                    {turn.currents.length > 0 &&
                                        turn.currents.map((current, index) => {
                                            return <DescriptionWrapper lang={lang} desc={current} setSelected={setSelected} key={v4()} />;
                                        })}

                                    {turn.afters.length > 0 && (
                                        <div className={styles["description-title"]}>{getUIText(lang, "schedule.turn.action.after")}</div>
                                    )}
                                    {turn.afters.length > 0 &&
                                        turn.afters.map((after, index) => {
                                            return <DescriptionWrapper lang={lang} desc={after} setSelected={setSelected} key={v4()} />;
                                        })}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
